// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import translate from "@insite/client-framework/Translate";
import Link, { LinkProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Typography from "@insite/mobius/Typography";
import { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useLoadProductById from "@store/Framework/Store/Data/Products/ProductsHooks/useLoadProductById";
import { loadingDotsAnimation } from "@store/Themes/common/mixins/typography";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { css } from "styled-components";

const InfosBox = getWidgetComponent("InfosBox");

type OwnProps = HasProduct;
type Props = OwnProps;

export interface StoreSupercededProductLabelStyles {
    loadingText?: TypographyPresentationProps;
    supercededText?: TypographyPresentationProps;
    supercededProductLink?: LinkProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
}

const styles: StoreSupercededProductLabelStyles = {
    spinner: {
        size: 30,
    },
    loadingText: {
        css: css`
            ${loadingDotsAnimation()}
        `,
    },
    supercededText: {
        color: "text.main",
    },
    supercededProductLink: {
        color: "text.main",
        typographyProps: {
            underline: true,
            css: css`
                ${({ theme }) => theme.design.typography.weight.bold}
            `,
        },
    },
};

export const storeSupercededProductLabelStyles = styles;

const StoreSupercededProductLabel: React.FC<Props> = ({ product }) => {
    const loadProductById = useLoadProductById();

    const { supercededProduct } = useSelector((state: ApplicationState) => {
        const productState = getProductState(state, product.detail?.replacementProductId ?? undefined);

        return {
            supercededProduct: productState.value,
        };
    });

    useEffect(() => {
        if (product.detail?.replacementProductId) {
            loadProductById(product.detail.replacementProductId);
        }
    }, []);

    if (!supercededProduct) {
        return (
            <StyledWrapper {...styles.centeringWrapper}>
                <LoadingSpinner {...styles.spinner} />
            </StyledWrapper>
        );
    }

    const infoContent = () => {
        return supercededProduct !== undefined ? (
            <Typography {...styles.supercededText}>
                {translate("This product has been superceded by ")}
                {supercededProduct ? (
                    <Link href={supercededProduct.canonicalUrl} target="_blank" {...styles.supercededProductLink}>
                        {supercededProduct.productNumber}
                    </Link>
                ) : (
                    <Typography {...styles.loadingText} />
                )}
            </Typography>
        ) : null;
    };

    return <InfosBox type="warning" size="small" content={infoContent()} />;
};

export default withProduct(StoreSupercededProductLabel);
